import { render, staticRenderFns } from "./HistoricoProceso.vue?vue&type=template&id=2f1787cd&scoped=true"
import script from "./HistoricoProceso.vue?vue&type=script&lang=js"
export * from "./HistoricoProceso.vue?vue&type=script&lang=js"
import style0 from "./HistoricoProceso.vue?vue&type=style&index=0&id=2f1787cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1787cd",
  null
  
)

export default component.exports